export default {
  ThisDay: "Today",
  ThisWeek: "Current week",
  FirstWeekToPresent: "Early week to present",
  ThisMonth: "This month",
  Last30Days: "Last 30 days",
  FirstMonthToPresent: "Early month to present",
  ThisQuarter: "This quarter",
  FirstQuarterToPresent: "Early quarter to present",
  ThisYear: "This year",
  FirstYearToPresent: "Early year to present",
  SixFirstMonth: "First half of the year",
  SixLastMonth: "Second half of the year",
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  FiscalI: "Quarter I",
  FiscalII: "Quarter II",
  FiscalIII: "Quarter III",
  FiscalIV: "Quarter IV",
  Yesterday: "Yesterday",
  LastWeek: "Last week",
  LastMonth: "Last month",
  LastQuarter: "Last quarter",
  LastYear: "Last year",
  Tomorrow: "Tomorrow",
  NextWeek: "Next week",
  NextMonth: "Next month",
  NextQuarter: "Next quarter",
  NextYear: "Next year",
  Custom: "Optional",
  Last7Day: "Last 7 days",
  Other: "Optional",
  DateStringFormat: "{0}/{1}/{2}",
  DateFormat: "Date {0} Month {1} Year {2}",
  YearFormat: "Year {0}",
  MonthFormat: "Month {0} Year {1}",
  QuarterFormat: "Quarter {0} Year {1}",
  FromDateToDateFormat: "From {0} to {1}",
  FullDateFormat: "DD/MM/YYYY",
  ReportDateFormat: "Day {0}",
  ToDateFormat: "To {0}",

  Month: 'Month',
  Quarter: 'Quarter',
  Year: 'Year',
};
